import React from 'react';
import {
  makeStyles,
  FormControl,
  FormControlLabel,
  Checkbox,
  FormLabel,
  FormGroup,
} from '@material-ui/core';
import {
  TEpDevPEntityId
} from '@solace-labs/backstage-plugin-ep-devp-common';
import {
  EpDevPSearchContextValue,
  useEpDevPSearch
} from '../../context';


const useStyles = makeStyles(
  theme => ({
    label: {
      textTransform: 'capitalize',
      marginBottom: theme.spacing(1),
    },
    item: {
      marginLeft: `calc(-${theme.spacing(0.5)}px - 2px)`,
    },
    checkbox: {
      padding: theme.spacing(0.5),
    },
  }),
);

export interface IEpDevPSearchFilterCheckboxProps {
  className?: string;
  title?: string;
  searchFieldName: string;
  valuesEntityIdList: Array<TEpDevPEntityId>;
}

export const EpDevPSearchFilterCheckbox = (props: IEpDevPSearchFilterCheckboxProps) => {

  const classes = useStyles();
  const { className, title, valuesEntityIdList } = props;

  const useSearchContext: EpDevPSearchContextValue = useEpDevPSearch();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { target: { value, checked } } = e;

    // console.log(` - prevCustomFilters = ${JSON.stringify(useSearchContext.filters.customFilters, null, 2)}`);
    // console.log(` - value = ${JSON.stringify(value, null, 2)}`);
    // console.log(` - checked = ${JSON.stringify(checked, null, 2)}`);

    const customFilters = useSearchContext.filters.customFilters || {};
    let newCustomFilterList: Array<string> = [];
    if (customFilters[props.searchFieldName]) {
      newCustomFilterList = JSON.parse(JSON.stringify(customFilters[props.searchFieldName])) as Array<string>;
    }
    // console.log(` - newCustomFilterList(before) = ${JSON.stringify(newCustomFilterList, null, 2)}`);
    // add or remove if exists
    if (checked) {
      const found = newCustomFilterList.find((x) => { return x === value; });
      if (!found) newCustomFilterList.push(value);
    } else {
      const idx = newCustomFilterList.findIndex((x) => { return x === value; });
      if (idx > -1) newCustomFilterList.splice(idx, 1);
    }
    // console.log(` - newCustomFilterList(after) = ${JSON.stringify(newCustomFilterList, null, 2)}`);
    // add into filters
    const newCustomFilters = JSON.parse(JSON.stringify(customFilters));
    newCustomFilters[props.searchFieldName] = newCustomFilterList.length > 0 ? newCustomFilterList : undefined;

    useSearchContext.setCustomFilters(newCustomFilters);
  };

  if (valuesEntityIdList.length === 0) return (<></>);
  return (
    <FormControl
      className={className}
      fullWidth
      size="small"
      data-testid="search-checkboxfilter-next"
    >
      {title && (
        <FormLabel className={classes.label}>{title}</FormLabel>
      )}
      <FormGroup>
        {valuesEntityIdList.map(item => {
          const { id, displayName } = item;
          return (
            <FormControlLabel
              classes={{ root: classes.item }}
              key={id}
              control={
                <Checkbox
                  className={classes.checkbox}
                  color="primary"
                  value={id}
                  name={displayName}
                  onChange={handleChange}
                />
              }
              label={displayName}
            />
          );
        })}
      </FormGroup>
    </FormControl>
  );
};

